module.exports = "<p>\n  {{ 'app.error.forbidden' | translate }}\n</p>\n"